import { render, staticRenderFns } from "./addserver.vue?vue&type=template&id=7c67ab1f&scoped=true&"
import script from "./addserver.vue?vue&type=script&lang=js&"
export * from "./addserver.vue?vue&type=script&lang=js&"
import style0 from "./addserver.vue?vue&type=style&index=0&id=7c67ab1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c67ab1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c67ab1f')) {
      api.createRecord('7c67ab1f', component.options)
    } else {
      api.reload('7c67ab1f', component.options)
    }
    module.hot.accept("./addserver.vue?vue&type=template&id=7c67ab1f&scoped=true&", function () {
      api.rerender('7c67ab1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/groupServer/components/addserver.vue"
export default component.exports